import { useQuery } from '@tanstack/react-query';
import * as bundlesData from '@/data/bundles';
import type { BundleFilters } from '@/contracts/bundles';

export function useRetailers() {
  return useQuery({
    queryKey: ['retailers'],
    queryFn: bundlesData.getRetailers,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useKitTypes() {
  return useQuery({
    queryKey: ['kit-types'],
    queryFn: bundlesData.getKitTypes,
    staleTime: 5 * 60 * 1000,
  });
}

export function useBundleVersions() {
  return useQuery({
    queryKey: ['bundle-versions'],
    queryFn: bundlesData.getBundleVersions,
    staleTime: 5 * 60 * 1000,
  });
}

export function useBundles(filters: BundleFilters) {
  return useQuery({
    queryKey: ['bundles', filters],
    queryFn: () => bundlesData.getBundles(filters),
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

export function useBundle(slug: string) {
  return useQuery({
    queryKey: ['bundle', slug],
    queryFn: () => bundlesData.getBundleBySlug(slug),
    staleTime: 5 * 60 * 1000,
    enabled: !!slug,
  });
}
